<!--团体报告-->
<template>
  <a-card>
    <div class="search">
      <a-form-model layout="inline" :model="searchForm">
        <a-form-model-item label="报告名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.name" placeholder="请输入报告名称" />
        </a-form-model-item>
        <a-form-model-item label="机构名称">
          <a-select showSearch optionFilterProp="title" class="serach-item" allowClear v-model="searchForm.organizationId" placeholder="请选择机构名称">
            <a-select-option :value="item.id" :key="item.id" :title="item.name" v-for="item in organizationList">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="项目名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.projectName" placeholder="请输入项目名称" />
        </a-form-model-item>
        <a-form-model-item label="报告类型">
          <a-select class="serach-item" allowClear v-model="searchForm.reportType" placeholder="请选择报告类型">
            <a-select-option :value="1">校级团体报告</a-select-option>
            <a-select-option :value="2">区域团体报告</a-select-option>
            <a-select-option :value="3">单校对比报告</a-select-option>
            <a-select-option :value="4">多校对比报告</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select class="serach-item" allowClear v-model="searchForm.status" placeholder="请选择报告状态">
            <a-select-option :value="item.value" :key="item.value" v-for="item in statusList">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item style="margin-right: 35px">
          <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询 </a-button>
          <a-button @click="searchReset" style="margin-left: 10px"> 重置 </a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`groupReport.Add`">
          <a-button @click="addReport" icon="plus" type="primary">添加报告</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <a-table
      :columns="columns"
      style="min-width: 800px"
      :rowKey="(text, index) => text.id + index"
      :pagination="tableRelevant.tablePagination"
      :loading="tableRelevant.tableLoading"
      :locale="tableRelevant.locale"
      :dataSource="tableRelevant.tableDataSource"
    >
      <div :title="text && text.join('，')" class="table-orgName" slot="organizationName" slot-scope="text">
        {{ text && text.join('，') }}
      </div>
      <span slot="reportType" slot-scope="text">
        <span v-if="text === 1">校级团体报告</span>
        <span v-if="text === 2">区域团体报告</span>
        <span v-if="text === 3">单校对比报告</span>
        <span v-if="text === 4">多校对比报告</span>
      </span>
      <div slot="status" slot-scope="text">
        <span v-if="text.status === 0" style="color: #409eff">配置中</span>
        <!-- <span v-else-if="text.status === 1" style="color: #302bb6">计划生成：{{ text.reportTime }}</span> -->
        <span v-else-if="text.status === 1" style="color: #302bb6">生成中</span>
        <span v-else-if="text.status === 2" style="color: #e6a23c">生成中</span>
        <span v-else-if="text.status === 3" style="color: #67c23a">已生成</span>
        <span v-else-if="text.status === 4" style="color: #f56c6c">生成失败</span>
        <span v-else-if="text.status === 6" style="color: #03b4db">已发布</span>
        <span v-else style="color: #909399">处理中</span>
      </div>
      <div slot="action" slot-scope="text">
        <a v-permission="`groupReport.Edit`" style="margin-right: 10px" href="javaScript:;">
          <span v-if="[0, 3, 4, 6].includes(text.status)" @click="edit(text)"><a-icon type="edit" /> 编辑</span>
          <span v-else style="color: #ccc"><a-icon type="edit" /> 编辑</span>
        </a>
        <a-popconfirm title="确认删除此报告？" @confirm="del(text)">
          <a v-permission="`groupReport.Delete`" style="color: red; margin-right: 10px" href="javaScript:;">
            <a-icon type="delete" />
            删除</a
          >
        </a-popconfirm>
        <a-dropdown>
          <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-permission="`groupReport.Again`">
              <a href="javaScript:;" v-if="isResetGenReport(text)" @click="generateGroupReport(text)">重新生成</a>
              <a v-else style="color: #ccc" href="javaScript:;">重新生成</a>
            </a-menu-item>

            <a-menu-item v-permission="`groupReport.Replace`" v-if="text.status != 0">
              <a v-if="text.status === 3 || text.status === 6" @click="replaceOpen(text)">替换报告</a>
              <a v-else style="color: #ccc" href="javaScript:;">替换报告</a>
            </a-menu-item>
            <a-menu-item v-permission="`groupReport.Download`">
              <a v-if="(text.status === 3 || text.status === 6) && text.wordReportUrl" download :href="text.wordReportUrl | filterUrl">下载报告</a>
              <a v-else style="color: #ccc" href="javaScript:;">下载报告</a>
            </a-menu-item>
            <a-menu-item v-permission="`groupReport.DownloadPPT`" v-if="text.pptUrl">
              <a v-if="[3, 6].includes(text.status) && text.pptUrl" download :href="text.pptUrl | filterUrl">下载PPT</a>
              <a v-else style="color: #ccc" href="javaScript:;">下载PPT</a>
            </a-menu-item>
            <a-menu-item v-permission="`groupReport.Look`">
              <a v-if="text.status !== 0" @click="look(text)" href="javaScript:;">查看详情</a>
              <a v-else style="color: #ccc" href="javaScript:;">查看详情</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </a-table>

    <!--添加/编辑报告-->
    <a-modal v-model="modelForm.visible" :centered="true" :footer="null" width="100%" wrapClassName="create-report" @cancel="modelFormCancel" :destroyOnClose="true" :title="modelForm.title">
      <CreateReport :report-id="modelForm.id" />
    </a-modal>

    <!--查看报告详情-->
    <a-modal v-model="lookReport.visible" :centered="true" :footer="null" width="100%" wrapClassName="create-report" :destroyOnClose="true" title="报告详情">
      <LookReport :report-info="lookReport.info" />
    </a-modal>

    <!--替换报告-->
    <a-modal v-model="replace.visible" @ok="replaceOk" :confirm-loading="replace.loading" @cancel="closeModle" :destroyOnClose="true" title="替换报告">
      <a-upload-dragger name="file" :file-list="replace.fileList" :remove="handleRemove" :before-upload="beforeUpload" @change="unploadChange">
        <h4 class="um-upload">上传文件</h4>
        <p class="ant-upload-drag-icon">
          <a-icon type="cloud-upload" />
        </p>
        <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
        <!-- <p class="ant-upload-hint">（支持扩展名为doc或者docx文件）</p> -->
      </a-upload-dragger>
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import CreateReport from './createReport/CreateReport'
import LookReport from './lookReport/LookReport'
import $Bus from '@/pages/projectImpl/js/eventBus'
import Apis from '@/requests/apis'

const columns = [
  {
    title: '报告名称',
    dataIndex: 'name',
    ellipsis: true,
    width: 200,
  },
  {
    title: '报告类型',
    dataIndex: 'reportType',
    width: 150,
    scopedSlots: { customRender: 'reportType' },
  },
  {
    title: '项目名称',
    dataIndex: 'projectName',
    ellipsis: true,
  },
  {
    title: '机构名称',
    dataIndex: 'organizationName',
    width: 300,
    scopedSlots: { customRender: 'organizationName' },
    // ellipsis: true
  },
  {
    title: '状态',
    width: 150,
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '更新时间',
    width: 140,
    align: 'center',
    dataIndex: 'updateTime',
  },
  {
    title: '创建时间',
    width: 140,
    align: 'center',
    dataIndex: 'createTime',
  },
  {
    width: 200,
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'GroupReport',
  components: { CreateReport, LookReport },
  data() {
    return {
      columns,
      searchForm: {
        name: undefined,
        projectName: undefined,
        organizationId: undefined,
        reportType: undefined,
        status: undefined,
      },
      organizationList: [],
      statusList: [
        { name: '配置中', value: 0 },
        { name: '处理中', value: 5 },
        { name: '生成中', value: 2 },
        { name: '已生成', value: 3 },
      ],
      //表格相关
      tableRelevant: tableRelevant.call(this),
      //添加、编辑报告相关
      modelForm: {
        visible: false,
        confirmLoading: false,
        title: '添加报告',
        id: '',
      },
      //查看报告
      lookReport: {
        visible: false,
        info: {},
      },
      // 替换报告
      replace: {
        visible: false,
        loading: false,
        fileList: [],
        file: '',
        id: '',
      },
    }
  },
  computed: {
    isResetGenReport() {
      // 对于生成中的报告，超过十分钟没有生成成功，则可以重新生成
      const expDelay = 1000 * 60 * 10
      return (record) => {
        return [3, 4, 5, 6].includes(record.status) || (+new Date(record.updateTime) + expDelay < +new Date() && [2, 1].includes(record.status))
      }
    },
  },
  mounted() {
    this.getPageList()
    this.getOrganizationList()
    $Bus.$on('closeCreateReport', () => {
      this.modelFormCancel()
    })
    $Bus.$on('copyReport', (id) => {
      this.modelForm.id = id
      this.modelForm.visible = true
      this.modelForm.title = '编辑报告'
      this.lookReport.visible = false
    })
  },
  methods: {
    //获取报告列表
    getPageList(pageIndex) {
      if (pageIndex) {
        this.tableRelevant.tablePagination.current = pageIndex
      }
      const params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.getGroupList(params)
        .then((res) => {
          const { data } = res
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = data.totalCount
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    //获取所有机构
    getOrganizationList() {
      this.$http.loadAllByType({ isOnlySuperior: false }).then((res) => {
        const { data } = res.data
        this.organizationList = data
      })
    },

    //重置
    searchReset() {
      this.searchForm = {
        name: undefined,
      }
      this.getPageList(1)
    },
    //添加报告
    addReport() {
      this.modelForm.title = '添加报告'
      this.modelForm.id = ''
      this.$store.commit('organization/setReportInfo', {})
      this.modelForm.visible = true
    },
    //编辑报告
    edit(val) {
      this.modelForm.title = '编辑报告'
      this.modelForm.id = val.id
      this.modelForm.visible = true
    },
    //删除报告
    del(val) {
      this.$http.ReportService.deleteGroupReport(val.id)
        .then((res) => {
          const { data, status, message } = res
          this.$message.success(message)
          this.getPageList(1)
        })
        .finally(() => {
          this.tableRelevant.tableLoading = true
        })
    },
    //修改报告状态
    reload(val, s = 2) {
      const fn = () => {
        this.tableRelevant.tableLoading = true
        this.$http.GroupReport.updateStatus(
          new URLSearchParams({
            id: val.id,
            status: s,
          })
        )
          .then((res) => {
            const { message } = res
            this.$message.success(message)
            this.getPageList(1)
          })
          .finally(() => {
            this.tableRelevant.tableLoading = false
          })
      }
      if (s === 6) {
        this.$confirm({
          title: '确认发布此报告？',
          centered: true,
          onOk: () => {
            fn()
          },
        })
        return
      }
      fn()
    },
    // 重新生成报告
    generateGroupReport(val) {
      this.$confirm({
        title: '确认重新生成此报告？',
        centered: true,
        onOk: () => {
          this.tableRelevant.tableLoading = true
          this.$http.ReportService.genGroupReport(val.id)
            .then((res) => {
              const { message } = res
              this.$message.success(message)
              this.getPageList()
            })
            .finally(() => {
              this.tableRelevant.tableLoading = false
            })
        },
      })
    },
    //查看报告详情
    look(val) {
      const record = { ...val, organizationName: val.organizationName.join(',') }
      this.lookReport.info = record
      this.$store.commit('organization/setReportInfo', record)
      this.lookReport.visible = true
    },

    //添加编辑报告弹出框确认
    modelFormOk() {
      this.$refs.myModelForm.validate((valid) => {
        if (valid) {
          const bool = this.modelForm.title === '添加报告'
          const Ajax = bool ? this.$http.GroupReport.groupReportAdd : this.$http.GroupReport.groupReportUpdate
          const form = new FormData()
          for (let key in this.modelForm.data) {
            form.append(key, this.modelForm.data[key])
          }
          if (bool) {
            form.delete('id')
          }
          this.modelForm.confirmLoading = true
          Ajax(form)
            .then((res) => {
              const { message } = res
              this.$message.success(message)
              this.modelFormCancel()
              this.getPageList(1)
            })
            .finally(() => {
              this.modelForm.confirmLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //添加编辑报告弹出框取消
    modelFormCancel() {
      const bool = this.modelForm.title === '添加报告'
      this.modelForm.visible = false
      this.modelForm.title = '添加报告'
      this.modelForm.id = ''
      this.$store.commit('organization/setReportInfo', {})
      if (bool) {
        this.getPageList(1)
      } else {
        this.getPageList()
      }
    },
    // 替换报告
    replaceOpen(record) {
      console.log(record)
      this.replace.visible = true
      this.replace.id = record.id
    },
    handleRemove(file) {
      const index = this.replace.fileList.indexOf(file)
      const newFileList = this.replace.fileList.slice()
      newFileList.splice(index, 1)
      this.replace.fileList = newFileList
    },
    beforeUpload(file) {
      const bool = this.replace.fileList.filter((v) => v.name === file.name).length
      if (bool) {
        this.replace.$message.warning('已有相同的文件，请重新选择文件')
        return false
      }
      // this.replace.fileList = [...this.replace.fileList, file];
      this.replace.fileList = [file]
      return false
    },
    unploadChange(value) {
      if (value.fileList.length) {
        this.replace.file = value.file
      } else {
        this.replace.file = ''
      }
    },
    replaceOk() {
      if (this.replace.file == '') {
        this.$message.destroy()
        this.$message.warning('请选择文件')
        return
      }
      this.replace.loading = true
      let url = '/file/file/upload?filePath=GroupReports/' + this.replace.id + '&fileName=' + this.replace.file.name
      let formData = new FormData()
      formData.append('imgFile', this.replace.file)
      this.$http.File.upload(url, formData)
        .then((data) => {
            this.submit(data.data)

        })
        .finally(() => {
          this.replace.loading = false
        })
    },
    submit(url) {
      let formData = new FormData()
      formData.append('wordReportUrl', url)
      formData.append('groupReportId', this.replace.id)
      this.$http.GroupReport.replaceReport(formData)
        .then((res) => {
          this.$message.destroy()
            this.$message.success('操作成功')
            this.getPageList()
            this.replace.visible = false
            this.replace.fileList = []
            this.replace.file = ''

        })
        .finally(() => {
          this.replace.loading = false
        })
    },
    closeModle() {
      this.replace.visible = false
      this.replace.fileList = []
      this.replace.file = ''
    },
  },
}
</script>

<style scoped lang="less">
.serach-item {
  width: 180px;
  margin-bottom: 15px;
}

/deep/ .create-report .ant-modal {
  width: 100%;
  height: 100%;
  padding-bottom: 0;
}

/deep/ .create-report .ant-modal-content {
  height: 100%;
  padding-bottom: 0;
}

::v-deep .ant-table-row-cell-ellipsis:not(.ant-table-row-cell-break-word) {
  font-size: 0;
}
.table-orgName {
  overflow: hidden;
  /* 三行显示省略号 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
